import { supabase } from "@/integrations/supabase/client";

/**
 * Updates the user's last_login_at timestamp to track meaningful activity.
 * Fails silently to not disrupt the main user action.
 */
export async function trackActivity() {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase
      .from('profiles')
      .update({ last_login_at: new Date().toISOString() })
      .eq('id', user.id);
  } catch (error) {
    // Fail silently - activity tracking should never block user actions
    console.error('Activity tracking failed:', error);
  }
}
